// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
var IosWebPage = /* #__PURE__ */ (function () {
    function IosWebPage() {

    };
    IosWebPage.value = new IosWebPage();
    return IosWebPage;
})();
var IosMobileApp = /* #__PURE__ */ (function () {
    function IosMobileApp() {

    };
    IosMobileApp.value = new IosMobileApp();
    return IosMobileApp;
})();
var getMobileAppType = function __do() {
    var appType = $foreign.getMobileAppTypeImpl();
    if (appType === "IosWebPage") {
        return new Data_Maybe.Just(IosWebPage.value);
    };
    if (appType === "IosMobileApp") {
        return new Data_Maybe.Just(IosMobileApp.value);
    };
    return Data_Maybe.Nothing.value;
};
var isAndroid = function __do() {
    var isMobileApp$prime = $foreign.isMobileApp();
    var iosAppType = getMobileAppType();
    if (iosAppType instanceof Data_Maybe.Just) {
        return false;
    };
    if (iosAppType instanceof Data_Maybe.Nothing) {
        return isMobileApp$prime;
    };
    throw new Error("Failed pattern match at Restaumatic.Environment (line 40, column 10 - line 42, column 28): " + [ iosAppType.constructor.name ]);
};
var eqAppType = {
    eq: function (x) {
        return function (y) {
            if (x instanceof IosWebPage && y instanceof IosWebPage) {
                return true;
            };
            if (x instanceof IosMobileApp && y instanceof IosMobileApp) {
                return true;
            };
            return false;
        };
    }
};
export {
    isMobileApp,
    isInIframe,
    mobileGeolocationEnabled,
    isIosReviewMode
} from "./foreign.js";
export {
    getMobileAppType,
    isAndroid,
    IosWebPage,
    IosMobileApp,
    eqAppType
};
